import { useEffect, useRef, useState } from "react";
import BranchService, { Branch } from "../features/branch/services/branch-service";

export interface StoreOption {
  value: number;
  label: string;
}

/**
 * Hook dùng để lấy danh sách chi nhánh mà user có quyền truy cập
 * - Nếu user có is_all_branch = 1 hoặc quyền ADMIN → trả về tất cả chi nhánh
 * - Còn lại → trả về chi nhánh được phân công trong user_branch_maps
 * Trả về options { value, label } để dùng trong react-select
 */
export const useStoreOptions = () => {
  const [options, setOptions] = useState<StoreOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Gọi hook trong service - sử dụng myBranches thay vì listActive
  const { fetch: fetchMyBranches, loading: apiLoading } = BranchService.myBranches();
  const fetchRef = useRef(fetchMyBranches);
  useEffect(() => {
    fetchRef.current = fetchMyBranches;
  }, [fetchMyBranches]);

  // Fetch 1 lần khi mount
  const fetchedRef = useRef(false);
  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetchRef.current();
        if (!cancelled && res?.data && Array.isArray(res.data)) {
          const list: Branch[] = res.data;
          setOptions(list.map((b) => ({ value: b.id, label: b.name })));
        }
      } catch (err: any) {
        console.error("❌ Lỗi khi lấy danh sách chi nhánh:", err);
        if (!cancelled) {
          setError(err?.message || "Không thể lấy danh sách chi nhánh");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { options, loading: loading || apiLoading, error };
};
